<div class="breadcrumbs">
  <div>/</div>
  <div>Governance</div>
  <div>/</div>
  <div class="hasLink" [routerLink]="['/data-catalogue']">Data Catalogues</div>
  <div>/</div>
  <div>Facilis Origin AIXM 5.1</div>
  <div>/</div>
  <div>Data type: {{ dataType }}</div>
</div>

<mat-toolbar class="toolbar-custom">
  <span>
    <h3>Data type: {{ dataType }}</h3>
  </span>
</mat-toolbar>

<mat-expansion-panel class="custom-panel">
  <mat-expansion-panel-header>
    <mat-panel-title><b>Metadata</b></mat-panel-title>
  </mat-expansion-panel-header>

  <div class="metadata-content">
    <div class="metadata-item">
      <div class="metadata-key">Identifier:</div>
      <div class="metadata-value">{{ dataType }}</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key">Catalogue item type:</div>
      <div class="metadata-value">Data type</div>
    </div>

    <div></div>
    <div class="metadata-item">
      <div class="metadata-key">Last edited by:</div>
      <div class="metadata-value">{{ lastEditedBy }}</div>
    </div>
    <div class="metadata-item">
      <div class="metadata-key">Last edited on:</div>
      <div class="metadata-value">
        {{ (lastEditedOn && lastEditedOn !== '-') && lastEditedOn | date : "dd MMM yyyy" }}
      </div>
    </div>
  </div>
</mat-expansion-panel>

<div style="margin-left: 12px; margin-top: 20px">
  <b>UoM type: </b>
  <span class="hasLink" [routerLink]="['/data-catalogue']"
    >UomDistanceVerticalType</span
  >
</div>

<div class="table-wrapper">
  <table
    mat-table
    [dataSource]="allowedValues"
    class="mat-elevation-z2 full-width-table"
  >
    <ng-container matColumnDef="allowedValue">
      <th mat-header-cell *matHeaderCellDef>Allowed value</th>
      <td mat-cell *matCellDef="let element">{{ element.allowedValue }}</td>
    </ng-container>

    <ng-container matColumnDef="lock">
      <th mat-header-cell *matHeaderCellDef class="lock-column"></th>
      <td mat-cell *matCellDef="let element" class="lock-column">
        <mat-icon
          color="primary"
          style="cursor: pointer"
          (click)="openAccess(element.allowedValue)"
        >
          lock
        </mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="actions-column"></th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.allowedValue.startsWith('OTHER:')">
          <mat-icon
            style="color: black; cursor: pointer; margin-right: 6px"
            (click)="openDialog(element)"
            >edit</mat-icon
          >

          <mat-icon
            style="color: red; cursor: pointer; font-size: 31px"
            (click)="deleteEnum(element)"
            >clear</mat-icon
          >
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let element">{{ element.description }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <div class="table-actions">
    <button
      mat-raised-button
      color="primary"
      class="circle-btn"
      (click)="openDialog()"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
